import Vue from 'vue'
import Router from 'vue-router'
import Interceptor from '@/router/router.interceptor'

import LoginRoutes from '@/modules/login/login.routes'
import DashboardRoutes from '@/modules/dashboard/dashboard.routes'
import BuildRoutes from '@/modules/builds/builds.routes'
import SettingsRoutes from '@/modules/settings/settings.routes'
import ContentRoutes from '@/modules/content/content.routes'
import AppearanceRoutes from '@/modules/appearance/appearance.routes'
import ColorsRoutes from '@/modules/colors/colors.routes'
import TemplatesRoutes from '@/modules/templates/templates.routes'
import EDeliveryRoutes from '@/modules/edelivery-details/edelivery-details.routes'
import EDeliveryUserRoutes from '@/modules/edelivery/edelivery.routes'
import EmailsRoutes from '@/modules/emails/emails.routes'
import EnrollmentInvitationsRoutes from '@/modules/enrollment-invitations/enrollment-invitations.routes'
import NotificationsRoutes from '@/modules/notifications/notifications.routes'
import InsuredActionsRoutes from '@/modules/insuredactions/insuredactions.routes'
import GlobalSettingsRoutes from '@/modules/global-settings/global-settings.routes'
import ChartsRoutes from '@/modules/charts/charts.routes'
import GlobalChartsRoutes from '@/modules/charts/global-charts.routes'
import ContactManageRoutes from '@/modules/contacts/contact.routes'
import CustomPagesRoutes from '@/modules/custom-pages/custom-pages.routes'
import SMSRoutes from '@/modules/sms/sms.routes'
import CurrentBuildsRoutes from '@/modules/current-builds/current-builds.routes'
import CheckSettingRoutes from '@/modules/check-setting/check-setting.routes'

import AdministratorsRoutes from '@/modules/administrators/administrators.routes'
import GlobalInsuredActionsRoutes from '@/modules/insuredactions/global-insuredactions.routes'
import InsuredMessages from '@/modules/messages/insured-messages.routes'

import CompanySelectPage from '@/modules/dashboard/company-select.page'
import CompanyRootPage from '@/modules/dashboard/company-root.page'


Vue.use(Router)

let router = new Router({
  routes: [
    ...LoginRoutes,
    ...GlobalSettingsRoutes,
    ...GlobalChartsRoutes,
    ...GlobalInsuredActionsRoutes,
    {
      path: '/company-select',
      name: 'company-select',
      component: CompanySelectPage
    },
    ...NotificationsRoutes,
    ...AdministratorsRoutes,
    ...CurrentBuildsRoutes,
    ...CheckSettingRoutes,
    {
      path: '/company/:companyId',
      component: CompanyRootPage,
      children: [
        ...DashboardRoutes,
        ...ContactManageRoutes,
        ...BuildRoutes,
        ...SettingsRoutes,
        ...ContentRoutes,
        ...AppearanceRoutes,
        ...ColorsRoutes,
        ...TemplatesRoutes,
        ...EDeliveryRoutes,
        ...EDeliveryUserRoutes,
        ...EmailsRoutes,
        ...EnrollmentInvitationsRoutes,
        ...InsuredActionsRoutes,
        ...InsuredMessages,
        ...ChartsRoutes,
        ...CustomPagesRoutes,
        ...SMSRoutes,
      ],
    },
  ],
  mode: 'history',
})

Interceptor.attach(router)

export default router
